export const state = {
    payment: {
        amount: 0,
        subscriber_id: null,
        main_explaine: '',
        paymnet_type: 0,
    }
  };
  
  export const mutations = {
    SET_PAYMENT(state, detail) {
      state.payment = detail;
    }
  };
  
  export const actions = {
    setPayment({ commit }, detail) {
      commit('SET_PAYMENT', detail);
    }
  };
  
  export const getters = {
    getPayment: state => state.payment
  };
  
  